import styled from 'styled-components'
import { BLACK } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 0.2;
  color: ${BLACK};
  padding: 12px 24px;
`

export const Title = styled.span`
  font-family: ${INTER.bold};
  font-size: 24px;
  text-align: center;
`

export const Description = styled.span`
  font-family: ${INTER.regular};
  font-size: 16px;
  text-align: center;
`

export const PINContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 0.8;
  margin-top: 12px;
`
